import { PersonSettlementType as ApiPersonSettlementType } from 'src/api/generated/touring/types';
import { mapLinkableEntityType } from '../common';
import { PersonSettlementTourType } from './types';

export const mapPersonSettlementTourType = (
  apiPersonSettlement: ApiPersonSettlementType
): PersonSettlementTourType => {
  return {
    tour: mapLinkableEntityType(apiPersonSettlement.tour),
    artist: mapLinkableEntityType(apiPersonSettlement.artist),
    coHeadliner1: apiPersonSettlement.coHeadliner1
      ? mapLinkableEntityType(apiPersonSettlement.coHeadliner1)
      : null,
    coHeadliner2: apiPersonSettlement.coHeadliner2
      ? mapLinkableEntityType(apiPersonSettlement.coHeadliner2)
      : null,
    tourYear: apiPersonSettlement.tourYear,
  };
};
